import { ColDef, ICellRendererParams } from "ag-grid-community";
import { isSmartTag } from "../../../../filters/utils/helpers/isSmartTag";
import { Tag, Tags } from "@/services/cloudchipr.api";
import { TagCell } from "@/components/common/data-grid-cells/tag-cell/TagCell";

export const resourceSmartTagsColumnDefColId =
  "resourceSmartTagsColumnDefColId";

export const smartTagsColumnDef: ColDef = {
  colId: resourceSmartTagsColumnDefColId,
  minWidth: 210,
  sortable: false,
  hide: true,
  headerName: "Smart Tags",
  valueGetter: ({ data }) =>
    data?.resource?.tags
      ?.filter((tag: Tag) => isSmartTag(tag.key))
      ?.map((tag: Tag) => `${tag.key}: ${tag.value}`)
      ?.join(", "),
  cellRenderer: ({ data }: ICellRendererParams) => {
    const tags = data?.resource?.tags as Tags;

    return <TagCell smartTags tags={tags ?? []} />;
  },
};
